import { NavLink } from "react-router-dom";
import styled from "styled-components";
import Button from "../styles/Button";

const HeroSection = ({ myData }) => {
  const { name, img, qoutes } = myData;

  return (
    <Wrapper>
      <div className="container">
        <div className="grid grid-two-column">
          <div className="hero-section-data">
            <p className="intro-data">Welcome to </p>
            <h1> {name} </h1>
            <p>{qoutes}</p>
            <NavLink to="/products">
              <Button>show now</Button>
            </NavLink>
          </div>
          {/* our homepage image  */}
          <div className="hero-section-image">
            <figure>
              <img
                src={img}
                alt="hero-section-pic"
                className="img-style"
              />
            </figure>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  padding: 12rem 0;
  
  img {
    min-width: 10rem;
    height: 10rem;
  }
  .hero-section-data {
    margin: auto 0;
    p {
      margin: 2rem 0;
    }
    h1 {
      text-transform: capitalize;
      font-weight: bold;
    }
    .intro-data {
      margin-bottom: 0;
    }
  }
  .hero-section-image {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  figure {
    position: relative;
    &::after {
      content: "";
      width: 60%;
      height: 80%;
      background-color: #fb971b87;
      position: absolute;
      left: 45%;
      top: -2rem;
      z-index: -1;
    }
    &::before {
      content: "";
      width: 60%;
      height: 80%;
      background-color: #fb971b87;
      position: absolute;
      left: -5%;
      top: 8rem;
      z-index: -1;
    }
  }
  .img-style {
    width: 100%;
    height: auto;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
  }
  @media (max-width: ${({ theme }) => theme.media.mobile}) {
    .grid {
      gap: 10rem;
    }
    figure{
      padding-left:3rem;
    
    &::after {
      content: "";
      width: 50%;
      height: 85%;
      left: 0;
      top: 25%;
      background-color:  #fb971b87;
    }
  }
  }
`;

export default HeroSection;